var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-as-guage-container" }, [
    _c(
      "div",
      {
        staticClass: "yxtbiz-as-guage-container__guage",
        style: { height: this.height + "px" },
      },
      [_c("div", { attrs: { id: this.shapeId } })]
    ),
    _c("div", {
      staticClass: "yxtbiz-as-guage-container__guage-hide",
      style: { height: this.height * 0.14 + "px" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }